/* Makes the floating WhatsApp button draggable on mobile. A tap still opens
   WhatsApp; a drag repositions the button and the spot is remembered
   (localStorage) across page loads. Desktop keeps its fixed corner spot. */
(function () {
  var btn = document.querySelector('.whatsapp-float-btn');
  if (!btn) return;

  var STORAGE_KEY = 'wa-float-pos';
  var DRAG_THRESHOLD = 8;
  var EDGE_GAP = 8;

  var mq = window.matchMedia('(max-width: 768px)');

  var dragging = false;
  var moved = false;
  var suppressNextClick = false;
  var pointerId = null;
  var startX, startY, startLeft, startTop;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function applyPosition(left, top) {
    var rect = btn.getBoundingClientRect();
    var maxLeft = Math.max(EDGE_GAP, window.innerWidth - rect.width - EDGE_GAP);
    var maxTop = Math.max(EDGE_GAP, window.innerHeight - rect.height - EDGE_GAP);
    left = clamp(left, EDGE_GAP, maxLeft);
    top = clamp(top, EDGE_GAP, maxTop);
    btn.style.left = left + 'px';
    btn.style.top = top + 'px';
    btn.style.right = 'auto';
    btn.style.bottom = 'auto';
  }

  function savePosition() {
    var rect = btn.getBoundingClientRect();
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        xf: (rect.left + rect.width / 2) / window.innerWidth,
        yf: (rect.top + rect.height / 2) / window.innerHeight
      }));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — position just won't persist */
    }
  }

  function restorePosition() {
    var saved = null;
    try {
      saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      saved = null;
    }
    if (!saved || typeof saved.xf !== 'number' || typeof saved.yf !== 'number') return;

    var rect = btn.getBoundingClientRect();
    applyPosition(
      saved.xf * window.innerWidth - rect.width / 2,
      saved.yf * window.innerHeight - rect.height / 2
    );
  }

  function resetPosition() {
    btn.style.left = '';
    btn.style.top = '';
    btn.style.right = '';
    btn.style.bottom = '';
  }

  function onPointerDown(e) {
    if (!mq.matches || (e.button !== undefined && e.button !== 0)) return;
    dragging = true;
    moved = false;
    pointerId = e.pointerId;
    var rect = btn.getBoundingClientRect();
    startX = e.clientX;
    startY = e.clientY;
    startLeft = rect.left;
    startTop = rect.top;
    try { btn.setPointerCapture(pointerId); } catch (err) {}
  }

  function onPointerMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    var dx = e.clientX - startX;
    var dy = e.clientY - startY;
    if (!moved && Math.hypot(dx, dy) > DRAG_THRESHOLD) {
      moved = true;
      btn.classList.add('is-dragging');
    }
    if (moved) {
      applyPosition(startLeft + dx, startTop + dy);
    }
  }

  function onPointerUp(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    dragging = false;
    try { btn.releasePointerCapture(pointerId); } catch (err) {}
    if (moved) {
      btn.classList.remove('is-dragging');
      savePosition();
      suppressNextClick = true;
    }
    moved = false;
    pointerId = null;
  }

  btn.addEventListener('pointerdown', onPointerDown);
  btn.addEventListener('pointermove', onPointerMove);
  btn.addEventListener('pointerup', onPointerUp);
  btn.addEventListener('pointercancel', onPointerUp);

  btn.addEventListener('click', function (e) {
    if (suppressNextClick) {
      e.preventDefault();
      suppressNextClick = false;
    }
  });

  function onViewportChange() {
    if (mq.matches) {
      restorePosition();
    } else {
      resetPosition();
    }
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', onViewportChange);
  } else if (mq.addListener) {
    mq.addListener(onViewportChange);
  }

  window.addEventListener('resize', function () {
    if (!mq.matches) return;
    var rect = btn.getBoundingClientRect();
    applyPosition(rect.left, rect.top);
  });

  if (mq.matches) {
    restorePosition();
  }
})();
